const routes = [
  { path: "", redirect: "/login" },
  {
    path: "/login",
    name: "login",
    meta: { requiresAuth: false, layout: "simple-layout" },
    component: () =>
      import(/* webpackChunkName: "login" */ "@/views/login/Login.vue"),
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: () =>
      import(
        /* webpackChunkName: "dashboard" */ "@/views/dashboard/Dashboard.vue"
      ),
    meta: { requiresAuth: true, layout: "app-layout" },
  },
  {
    path: "/payments",
    name: "payments",
    component: () =>
      import(
        /* webpackChunkName: "payments" */ "@/views/payments/PaymentsOverview.vue"
      ),
    meta: { requiresAuth: true, requiresHotel: true, layout: "app-layout" },
  },
  {
    path: "/emailtemplates",
    name: "emailtemplates",
    component: () =>
      import(
        /* webpackChunkName: "templates" */ "@/views/emailTemplates/EmailTemplates.vue"
      ),
    meta: { requiresAuth: true, requiresHotel: true, layout: "app-layout" },
  },
  {
    path: "/accounts",
    name: "accounts",
    component: () =>
      import(
        /* webpackChunkName: "accounts" */ "@/views/accounts/Accounts.vue"
      ),
    meta: { requiresAuth: true, requiresHotel: true, layout: "app-layout" },
  },
  {
    path: "/reports",
    name: "reports",
    component: () =>
      import(/* webpackChunkName: "accounts" */ "@/views/reports/Reports.vue"),
    meta: { requiresAuth: true, requiresHotel: true, layout: "app-layout" },
  },
  {
    path: "*",
    name: "404",
    meta: { requiresAuth: false, layout: "simple-layout" },
    component: () =>
      import(/* webpackChunkName: "404" */ "@/views/PageNotFound.vue"),
  },
  {
    path: "/static",
    name: "static",
    meta: { requiresAuth: false, layout: "static-data-layout" },
    component: () =>
      import(/* webpackChunkName: "static" */ "@/views/StaticData.vue"),
  },
];

export default routes;
